import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'
import productTypes from 'helpers/enums/productTypes'
import productNameTypes from 'helpers/enums/productNameTypes'
import userRoleTypes from 'helpers/enums/userRoleTypes'
import academicLevelTypes from 'helpers/enums/academicLevelTypes'
import userAcademicLevel from 'redux/selectors/user/academic_level_selector'
import userDataSelector from 'redux/selectors/user/user_data_selector'
import config from 'config'

const user_badge_selector = createSelector(
	[ userDataSelector, userAcademicLevel ],
	(userData, userAcademicLevel) => {

		let badgeProductTitle = ''
		let badgeProduct = ''
		let linkMessage = ''
		let buttonRedirect = config.www + '?ph=1'
		let linkRedirect = config.www
		let buttonMessage = localize('sidebar_menu_explore_offers')

		const isAdmin = userData.account && userData.account.manage
		const isHigherED = userAcademicLevel === academicLevelTypes.HIGHER_ED

		switch (userData.productId) {
			case productTypes.SILVER:
				badgeProduct = badgeProductTitle = productNameTypes.SILVER
				buttonMessage = localize('global_upgrade')
				linkMessage = localize('sidebar_menu_news_and_offers')
				linkRedirect += '?ph=1'
				buttonRedirect = config.www + 'upgrade-account?oc=License+Block&utm_campaign=License+Block&utm_medium=inapp&utm_source=nearpod&utm_content=silver'
				break
			case productTypes.GOLD:
			case productTypes.GOLD_PLUS:
				badgeProduct = badgeProductTitle = productNameTypes.GOLD
				buttonMessage = localize('sidebar_menu_news_and_offers_button')
				linkMessage = localize('sidebar_menu_explore_nearpod_2')
				linkRedirect += 'school-license?oc=License+Block&utm_campaign=License+Block&utm_medium=inapp&utm_source=nearpod&utm_content=school'
				buttonRedirect = linkRedirect
				break
			case productTypes.SCHOOL:
				badgeProduct = productNameTypes.SCHOOL
				badgeProductTitle = isHigherED ? localize('global_university') : badgeProduct
				break
			case productTypes.CART:
				badgeProduct = badgeProductTitle = productNameTypes.CART
				break
			case productTypes.DISTRICT:
				badgeProduct = productNameTypes.DISTRICT
				badgeProductTitle = isHigherED ? localize('global_university') :
					userData.roleId === userRoleTypes.SCHOOL_ADMIN ? productNameTypes.SCHOOL : badgeProduct
				break
			case productTypes.PLATINUM:
				badgeProduct = badgeProductTitle = productNameTypes.PLATINUM
				buttonMessage = localize('sidebar_menu_news_and_offers_button')
				linkMessage = localize('sidebar_menu_explore_nearpod_2')
				linkRedirect += 'school-license?oc=License+Block&utm_campaign=License+Block&utm_medium=inapp&utm_source=nearpod&utm_content=district'
				buttonRedirect = linkRedirect
				break
		}

		const titleKey = isAdmin ? 'sidebar_badge_title_admin' : 'sidebar_badge_title'

		return {
			badgeTitle: `${badgeProductTitle} ${localize(titleKey)}`,
			badgeProduct,
			buttonMessage,
			buttonRedirect,
			linkRedirect,
			linkMessage,
		}
	}
)

export default user_badge_selector
